<template>
  <v-row>
    <v-col>
      <div v-html="registrationLevelText"></div>
    </v-col>
  </v-row>
  <v-row>
    <!-- Iterate over your array of branches -->
    <v-col
      v-for="product in availableProducts"
      :key="product.variants[0].id"
      cols="12"
      :md="12 / (availableProducts?.length ?? 1)">
      <v-sheet class="border-opacity-25 overflow-hidden border-thin rounded-lg">
        <v-card
          :elevation="selectedProductVariantId === product.variants[0].id ? 12 : 2"
          @click="selectProduct(product.variants[0].id)">
          <v-card-title>
            <v-row justify="space-between">
              <v-col class="text-left"> Level: {{ product.title }} </v-col>
              <v-col class="text-right" cols="auto">
                <v-icon
                  v-if="selectedProductVariantId === product.variants[0].id"
                  icon="mdi-check-circle"
                  color="green"></v-icon>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-subtitle
            >{{ product.teamLevel?.team_level }} - ${{ product.variants[0].price }}</v-card-subtitle
          >
          <v-card-text v-html="product.variants[0].description"></v-card-text>
          <!-- TODO: Add Addons -->
        </v-card>
      </v-sheet>
    </v-col>
  </v-row>
  <StudentValidationComponent
    :showStudentModal="showStudentModal"
    @studentVerified="studentIsVerified"
    @student-closed="showStudentModal = false">
  </StudentValidationComponent>
</template>
<script setup lang="ts">
import { computed, ref, toRef, watch } from 'vue';
import StudentValidationComponent from '@/components/registration/StudentValidationComponent.vue';
import { useAuthStore, useRegistrationStore, useYearStore } from '@/stores';
import { useProductStore } from '@/stores/modules/admin';
import { IProductDTO } from '@/dtos';
interface Props {
  selectedVariantProductId: string | undefined;
}
const props = defineProps<Props>();
const emit = defineEmits(['levelVerified']);
const yearStore = useYearStore();
const authStore = useAuthStore();
const registrationStore = useRegistrationStore();
const productStore = useProductStore();
const selectedProductVariantId = toRef(props, 'selectedVariantProductId', '');
const query = productStore.productsForYearQuery(ref(yearStore.currentYear?.id ?? ''));
const availableProducts = computed(() => query.data.value ?? ([] as IProductDTO[]));
const showStudentModal = ref<boolean>(false);
const registrationLevelText = computed(() => {
  return yearStore.currentYear?.registration_level_text ?? '';
});

const selectProduct = async (value: string) => {
  showStudentModal.value = false;
  registrationStore.addProductToRegistration.mutateAsync(value);
};

watch([availableProducts, selectedProductVariantId], async () => {
  const selectedProduct = availableProducts.value?.find(
    (product) => product.variants[0].id === selectedProductVariantId.value,
  );
  let isValidated = true;
  if (!selectedProduct || !selectedProduct.teamLevel) {
    isValidated = false;
  }

  if (isValidated && selectedProduct?.teamLevel?.team_level == 'Student') {
    if (
      !registrationStore.getMyRegistration.data?.validated &&
      !authStore.me?.email_address?.endsWith('.edu')
    ) {
      showStudentModal.value = true;
      isValidated = false;
    }
  }
  emit('levelVerified', isValidated);
  return isValidated;
});

const studentIsVerified = async (value: boolean) => {
  if (value) {
    showStudentModal.value = false;
    registrationStore.invalidateMyRegistration();
  }
};
</script>
